/**
 * Choix du modèle IA pour générer une SKILLCARD (recto, créature). Défaut =
 * celui de l'étape `card_generate` (Sonnet) ; Haiku plus rapide et économique,
 * Opus plus soigné et plus cher. Le serveur revalide l'identifiant.
 */

import {
  DEFAULT_STEP_MODELS,
  PIPELINE_MODELS,
  PIPELINE_MODEL_IDS,
  type PipelineModelId,
} from '@/lib/admin/pipeline-models';

export const CARD_DEFAULT_MODEL: PipelineModelId = DEFAULT_STEP_MODELS.card_generate;

const HINTS: Record<PipelineModelId, string> = {
  'claude-haiku-4-5-20251001': 'rapide, économique',
  'claude-sonnet-4-6': 'équilibré',
  'claude-opus-4-7': 'le plus soigné, plus cher',
};

export function AiModelSelect({
  value,
  onChange,
  disabled,
}: {
  value: PipelineModelId;
  onChange: (model: PipelineModelId) => void;
  disabled?: boolean;
}) {
  return (
    <label className="block space-y-1">
      <span className="text-ink-600 text-xs font-semibold">Modèle IA</span>
      <select
        className="border-ink-200 text-ink-900 min-h-[2.75rem] w-full rounded-lg border bg-white px-3 py-2 text-sm"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as PipelineModelId)}
      >
        {PIPELINE_MODEL_IDS.map((id) => (
          <option key={id} value={id}>
            {PIPELINE_MODELS[id].label} — {HINTS[id]}
            {id === CARD_DEFAULT_MODEL ? ' (par défaut)' : ''}
          </option>
        ))}
      </select>
    </label>
  );
}
